
const overview = resolve => require(['@/components/orderNew/overview'],resolve);
const goodsCompare = resolve => require(['@/components/orderNew/goodsCompare'],resolve);
const bandAnalysis = resolve => require(['@/components/orderNew/band'],resolve);
const structureAnalysis = resolve => require(['@/components/orderNew/structure'],resolve);
const structureCategory = resolve => require(['@/components/orderNew/structureCategory'],resolve);
const size = resolve => require(['@/components/orderNew/size'],resolve);
const sizeModel = resolve => require(['@/components/orderNew/sizeModel'],resolve);
const tagSkc = resolve => require(['@/components/orderNew/tagSkc'],resolve);
const bandColor = resolve => require(['@/components/orderNew/bandColor'],resolve);
const price = resolve => require(['@/components/orderNew/price'],resolve);
const mainPush = resolve => require(['@/components/orderNew/mainPush'],resolve);
const kjTag = resolve => require(['@/components/orderNew/kjTag'],resolve);
const areaOrderRank = resolve => require(['@/components/orderNew/areaOrderRank'],resolve);
const topSkc = resolve => require(['@/components/orderNew/topSkc'],resolve);
export default [
	{
		path : 'orderNew/overview',
		name : 'overview',
		meta : {
			title : '整体概况',
			searchDisabled : true,
			notNeedGlobalScroll : true
		},
		component : overview
	},
	{
		path : 'orderNew/compare',
		name : 'goodsCompare',
		meta : {
			title : '两年对比',
			searchDisabled : true,
			notNeedGlobalScroll : false
		},
		component : goodsCompare
	},
	{
		path : 'orderNew/band',
		name : 'bandAnalysis',
		meta : {
			title : '波段指引',
			searchDisabled : true,
			notNeedGlobalScroll : true
		},
		component : bandAnalysis
	},
	{
		path : 'orderNew/structure',
		name : 'structureAnalysis',
		meta : {
			title : '结构分析',
			searchDisabled : true,
			notNeedGlobalScroll : true
		},
		component : structureAnalysis
	},
	{
		path : 'orderNew/size',
		name : 'sizeDistribution',
		meta : {
			title : '品类尺码分析',
			searchDisabled : true,
			notNeedGlobalScroll : true
		},
		component : size
	},
	{
		path : 'orderNew/sizeModel',
		name : 'sizeModelDistribution',
		meta : {
			title : '尺码指引',
			searchDisabled : true,
			notNeedGlobalScroll : true
		},
		component : sizeModel
	},
	{
		path : 'orderNew/tag',
		name : 'tagSkc',
		meta : {
			title : '标签指引',
			searchDisabled : true,
			notNeedGlobalScroll : true
		},
		component : tagSkc
	},
	{
		path : 'orderNew/bandColor',
		name : 'bandColor',
		meta : {
			title : '色系指引',
			searchDisabled : true,
			notNeedGlobalScroll : true
		},
		component : bandColor
	},
	{
		path : 'orderNew/price',
		name : 'priceDistribution',
		meta : {
			title : '价格指引',
			searchDisabled : true,
			notNeedGlobalScroll : true
		},
		component : price
	},
	{
		path : 'orderNew/structureCategory',
		name : 'structureCategory',
		meta : {
			title : '品类指引',
			searchDisabled : true,
			notNeedGlobalScroll : true
		},
		component : structureCategory
	},
	{
		path : 'orderNew/mainPush',
		name : 'mainPush',
		meta : {
			title : '主推爆杆',
			searchDisabled : true,
			notNeedGlobalScroll : false
		},
		component : mainPush
	},
	{
		path : 'orderNew/kjTag',
		name : 'kjTag',
		meta : {
			title : '框架款指引',
			searchDisabled : true,
			notNeedGlobalScroll : false
		},
		component : kjTag
	},
	{
		path : 'orderNew/areaOrderRank',
		name : 'areaOrderRank',
		meta : {
			title : '区域订量排名',
			searchDisabled : true,
			notNeedGlobalScroll : false
		},
		component : areaOrderRank
	},
	{
		path : 'orderNew/topSkc',
		name : 'topSkc',
		meta : {
			title : 'TOP指引',
			searchDisabled : true,
			notNeedGlobalScroll : true
		},
		component : topSkc
	},
]



// WEBPACK FOOTER //
// ./src/router/orderNew/index.js